/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SidebarExpandAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SidebarExpandAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/UpperSection/SidebarExpandAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSidebarIsFloatingValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'sidebar.is_floating',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(tabSidebarIsFloatingValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}